export namespace  ObjectHelper {
    export function isNullOrUndefined(value?: any | undefined): boolean {
        if (value === null) {
            return true;
        }

        if (value === undefined) {
            return true;
        }

        return false;
    }

    export function isNotNullOrUndefined(value?: any | undefined): boolean {
        return !isNullOrUndefined(value);
    }

    export function CheckIfEmpty<T>(value: T | undefined, defaultValue: T): T {
        if (value === null) {
            return defaultValue;
        }

        if (value === undefined) {
            return defaultValue;
        }

        return value;
    }


    export function CheckValue<T>(value: T | undefined, defaultValue: T): void {
        if (isNullOrUndefined(value)) {
            value = defaultValue;
        }
    }

    export function CreateObject<T>(ctor: { new(): T }) {
        return new ctor();
    }
}


